const initialState = {
  typeProperty: 'teste',
  trialIsDone: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'TYPE_PROPERTY':
      const { typeProperty, trialIsDone } = action;
      return {
        ...state,
        typeProperty,
        trialIsDone,
      };
    default:
      return state;
  }
};

export const setTypeProperty = (typeProperty, trialIsDone) => ({
  type: 'TYPE_PROPERTY',
  typeProperty,
  trialIsDone,
});
